var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVehicleOwnerInverted(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Vehicle_Owner"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vehicle_Owner",
    "data-name": "Vehicle Owner",
    clipPath: "url(#clip-Vehicle_Owner)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_588",
    "data-name": "Group 588",
    transform: "translate(6 8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_398",
    "data-name": "Path 398",
    d: "M9.126,48.836h5.293a.555.555,0,0,0,.556-.556V44.656a.555.555,0,0,0-.556-.556H9.126a.555.555,0,0,0-.556.556V48.28A.555.555,0,0,0,9.126,48.836Zm.553-3.624h4.184v2.515H9.679Z",
    transform: "translate(-5.348 -25.637)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_574",
    "data-name": "Group 574",
    transform: "translate(24.155 1.526)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_399",
    "data-name": "Path 399",
    d: "M67.815,14.934V6.364a2.2,2.2,0,0,0-2.094-2.3H58.064a2.2,2.2,0,0,0-2.094,2.3v8.574a2.2,2.2,0,0,0,2.094,2.3h1.158l.023,4.992.981,1.3-1.113,1.419,1.113,1.4-1.113,1.4L60.2,29.12,59.09,30.344l2.8,3.234,2.673-3.036V17.237h1.158A2.2,2.2,0,0,0,67.815,14.934Zm-10.954,0V6.364a1.261,1.261,0,0,1,1.2-1.324h7.657a1.261,1.261,0,0,1,1.2,1.324v8.574a1.261,1.261,0,0,1-1.2,1.324H58.064A1.268,1.268,0,0,1,56.861,14.934Zm6.812,15.212-1.782,2.035-1.6-1.812,1.09-1.2-1.135-1.419,1.113-1.4-1.113-1.4,1.09-1.4L60.086,21.89l.023-4.653h3.564V30.146Z",
    transform: "translate(-55.97 -4.06)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_400",
    "data-name": "Path 400",
    d: "M69.058,11.637A1.349,1.349,0,0,0,67.7,10.28H62.427a1.349,1.349,0,0,0-1.357,1.357v.312a1.349,1.349,0,0,0,1.357,1.357H67.7a1.349,1.349,0,0,0,1.357-1.357S69.058,11.637,69.058,11.637Zm-.891.312a.468.468,0,0,1-.466.466H62.427a.468.468,0,0,1-.466-.466v-.312a.468.468,0,0,1,.466-.466H67.7a.468.468,0,0,1,.466.466S68.167,11.949,68.167,11.949Z",
    transform: "translate(-59.153 -7.942)",
    fill: "#ffffff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_401",
    "data-name": "Path 401",
    d: "M17.172,27.982H1.09V19.2a2.61,2.61,0,0,1,.688-1.786l1.481-1.505H17.172V14.672H15.427a.4.4,0,0,0,0-.1,4.91,4.91,0,0,0-4.661-5.127A4.91,4.91,0,0,0,6.1,14.577a.4.4,0,0,0,0,.1H3.552L5.071,7.857A3.243,3.243,0,0,1,8.154,5.178h9.022V3.95H8.131A4.372,4.372,0,0,0,3.97,7.564L2.327,15.135v.033L1.041,16.532A3.866,3.866,0,0,0,0,19.2V31.918a1.561,1.561,0,0,0,1.481,1.629h4.44A1.561,1.561,0,0,0,7.4,31.918V29.2h9.774v-1.22ZM7.214,14.593a3.736,3.736,0,0,1,3.552-3.9,3.738,3.738,0,0,1,3.549,3.9.833.833,0,0,0,.015.1H7.214A.4.4,0,0,0,7.214,14.593ZM6.27,31.922a.389.389,0,0,1-.368.405H1.462a.389.389,0,0,1-.368-.405V29.2h5.18v2.721Z",
    transform: "translate(0 -2.465)",
    fill: "#ffffff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y2: 31.082,
    transform: "translate(20.444)",
    stroke: "#ffffff",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleOwnerInverted);
export default __webpack_public_path__ + "static/media/vehicle-owner-inverted.1774be234c8ff0188c46d2d768fc8d4a.svg";
export { ForwardRef as ReactComponent };